module.exports = __webpack_public_path__ + "img/neck-mesomorph-male.2f1511de.svg";